// eslint-disable-next-line no-undef
APP.conf = {
  mobileOSConv: {
    'ios': 'apple',
    'android': 'android',
    'windows-phone': 'windows',
  },
  breakPoints: {
    mobile1Min: 320,
    mobile2Min: 408,
    tabletMin: 600,
    tablet2Min: 800,
    desktopMin: 1008,
    desktop2Min: 1280,
    desktop3Min: 1920,
  },
};
